import { parseReference } from '@skjv/common';
import { configureAiCommentaryPage } from './pdf-commentary-page.js';
/**
 * The commentary page on its own — for printing a commentary straight from
 * the AI view, with no study attached. Same renderer as the study lesson's
 * last page (pdf-commentary-page), so the printed page a reader gets from
 * the chat and the one bound into a lesson are the same page.
 *
 * The page needs a Study only for its running header (book abbreviation,
 * range, study name), so a minimal stand-in carries the commentary's own
 * reference and title.
 */
export async function generateCommentaryPdfBytes(opts) {
    const { jsPDF } = await import('jspdf');
    const doc = new jsPDF();
    await configureAiCommentaryPage(doc, standInStudy(opts.commentary), opts.verseTextSource);
    return doc.output('arraybuffer');
}
/** Minimal Study carrying just what the commentary page's header reads. */
function standInStudy(commentary) {
    const start = parseReference(commentary.reference);
    const range = commentary.reference.match(/^(.+?)\s+(\d+):(\d+)-(\d+)/);
    const end = range ? parseReference(`${range[1]} ${range[2]}:${range[4]}`) : null;
    return {
        id: 'commentary-only',
        name: commentary.pericopeTitle || commentary.reference,
        studyGroupId: '',
        startingLocation: start ?? undefined,
        endingLocation: end ?? undefined,
        scenes: [],
        assignments: [],
        teacherAssignments: [],
        aiCommentary: commentary,
    };
}
//# sourceMappingURL=generate-commentary-pdf.js.map